import { Swiper, Navigation, Mousewheel } from "swiper";

import ProductCardRenderer from "../common/product-card-renderer";
const productCardRenderer = ProductCardRenderer();

import Wishlist from "../common/wishlist";
const wishlist = Wishlist();

const renderProducts = (section) => {
  fetch(section.url)
    .then((response) => {
      return response.json();
    })
    .then(function (data) {
      if (!data || !data.preferences || !data.preferences[0] || !data.preferences[0].products) {
        const sectionElement = document.querySelector(`#shopify-section-${section.id}`);
        sectionElement.classList.add("hidden");
        return;
      }
      renderProductsWithIds(
        section,
        data.preferences[0].products.map((product) => product.id),
      );
    })
    .catch((e) => {
      /* console.error(e) */
      const sectionElement = document.querySelector(`#shopify-section-${section.id}`);
      sectionElement.classList.add("hidden");
    });
};

const renderProductsWithIds = (section, productIds) => {
  if (!window.ShopifyClient) {
    setTimeout(() => {
      renderProductsWithIds(ids);
    }, 400);
    return;
  }
  const ids = productIds.map((id) => "gid://shopify/Product/" + id);
  window.ShopifyClient.fetchProducts(ids)
    .then((products) => {
      products.forEach((product) => {
        wishlist.addShopifyProductToViewProducts(product);
      });
      const items = products.map((product) => {
        const item = productCardRenderer.renderShopifyProduct(product);
        return `<div class="swiper-slide">${item}</div>`;
      });
      const sectionElement = document.querySelector(`#shopify-section-${section.id}`);
      const swiperElement = sectionElement.querySelector(".swiper");
      const wrapperElement = swiperElement.querySelector(".swiper-wrapper");
      wrapperElement.innerHTML = items.join("");

      productCardRenderer.addWishlistButtonListener(wrapperElement);
      wishlist.updateButtons();

      section.swiper = new Swiper(swiperElement, {
        modules: [Navigation, Mousewheel],
        centerInsufficientSlides: true,
        speed: 300,
        slidesPerView: 2.5,
        slidesPerGroup: 1,
        spaceBetween: 8,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          sensitivity: 0.1,
          thresholdDelta: 10,
        },
        navigation: {
          nextEl: sectionElement.querySelector(".fs-swiper-navigation-next"),
          prevEl: sectionElement.querySelector(".fs-swiper-navigation-prev"),
        },
        breakpoints: {
          992: {
            speed: 900,
            slidesPerView: 4.5,
            slidesPerGroup: 4,
            spaceBetween: 12,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
          },
          1298: {
            speed: 900,
            slidesPerView: 5.4,
            slidesPerGroup: 5,
            spaceBetween: 12,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
          },
        },
      });
    })
    .catch((err) => {
      /* console.error(err) */
      const sectionElement = document.querySelector(`#shopify-section-${section.id}`);
      sectionElement.classList.add("hidden");
    });
};

const mediaSliderRecommend2023Main = () => {
  if (!window.fstore.sections) {
    return;
  }
  window.fstore.sections
    .filter((section) => section.sectionType == "media-slider-products-recommend")
    .forEach((section) => {
      renderProducts(section);
    });
};

addEventListener("DOMContentLoaded", (event) => {
  mediaSliderRecommend2023Main();
});
